/* ih-v3-header.js — announcement rotator, sticky state, mobile drawer (scoped to .ihv3h) */
(function () {
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init(scope) {
    var root = (scope || document).querySelector('.ihv3h');
    if (!root || root.__ihv3hDone) return;
    root.__ihv3hDone = true;

    /* header scrolled state */
    var hdr = root.querySelector('#hdr') || root.querySelector('header');
    if (hdr) {
      /* Hysteresis, not a single threshold. `.scrolled` shrinks .nav from 74px
         to 62px, and this header is position:sticky so that 12px comes out of
         the flow — which drags scrollY back across a single threshold and makes
         the state flip every frame. The 20px dead band below is wider than that
         12px delta, so the shrink can no longer undo its own trigger. */
      var ENTER = 28, LEAVE = 8;
      var isOn = false;
      var onScroll = function () {
        var y = window.scrollY;
        /* Guarded so the class is only written when the state actually changes.
           onScroll fires on every scroll event, including the burst the 300ms
           height transition produces, and an unguarded add/remove rewrites the
           attribute each time. */
        if (!isOn && y > ENTER) { isOn = true; hdr.classList.add('scrolled'); }
        else if (isOn && y < LEAVE) { isOn = false; hdr.classList.remove('scrolled'); }
        /* between LEAVE and ENTER: hold whatever state we are already in */
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }

    /* announcement rotator */
    var track = root.querySelector('#annTrack');
    if (track) {
      var msgs = Array.prototype.slice.call(track.querySelectorAll('.announce-msg'));
      var speed = parseInt(track.getAttribute('data-speed'), 10) || 3500;
      var i = 0, timer = null;
      var show = function (n) {
        i = (n + msgs.length) % msgs.length;
        msgs.forEach(function (m, k) { m.classList.toggle('on', k === i); });
      };
      var start = function () {
        if (reduceMotion || msgs.length < 2) return;
        timer = setInterval(function () { show(i + 1); }, speed);
      };
      var stop = function () { if (timer) { clearInterval(timer); timer = null; } };
      start();
      var prev = root.querySelector('#annPrev'), next = root.querySelector('#annNext');
      /* Sep 19 2026 (theme140), WCAG 2.2.2: rotation stops for good once the
         visitor uses an arrow or touches the bar (they have taken control), and
         pauses while the pointer OR keyboard focus is anywhere in the bar. It used
         to pause on mouseenter of the track only, so keyboard and touch users had
         no way to stop it. */
      var held = false, bar = track.closest('.announce') || track;
      var resume = function () { stop(); if (!held) start(); };
      if (prev) prev.addEventListener('click', function () { held = true; stop(); show(i - 1); });
      if (next) next.addEventListener('click', function () { held = true; stop(); show(i + 1); });
      bar.addEventListener('mouseenter', stop);
      bar.addEventListener('mouseleave', resume);
      bar.addEventListener('focusin', stop);
      bar.addEventListener('focusout', function (e) { if (!bar.contains(e.relatedTarget)) resume(); });
      bar.addEventListener('touchstart', function () { held = true; stop(); }, { passive: true });
    }

    /* Sep 19 2026 (theme140): the three mega buttons carried a permanent
       aria-expanded="false" while CSS opened their panels on :hover and
       :focus-within. Keep the attribute true to what is on screen. */
    Array.prototype.forEach.call(root.querySelectorAll('.nav-links > li'), function (li) {
      var btn = li.querySelector('button.toplink');
      if (!btn) return;
      var sync = function () {
        btn.setAttribute('aria-expanded', String(li.matches(':hover') || li.contains(document.activeElement)));
      };
      var later = function () { setTimeout(sync, 0); };
      li.addEventListener('mouseenter', sync);
      li.addEventListener('mouseleave', later);
      li.addEventListener('focusin', sync);
      li.addEventListener('focusout', later);
    });

    /* search bar (slides down under the header) */
    var sToggle = root.querySelector('#ihSearchToggle'),
        sBar = root.querySelector('#ihSearchBar'),
        sScrim = root.querySelector('#ihSearchScrim'),
        sInput = root.querySelector('#ihSearchInput'),
        sResults = root.querySelector('#ihSearchResults');
    if (sToggle && sBar) {
      var setSearch = function (open) {
        sBar.hidden = !open;
        if (sScrim) sScrim.hidden = !open;
        sToggle.setAttribute('aria-expanded', String(open));
        if (open && sInput) setTimeout(function () { sInput.focus(); }, 50);
        if (!open && sResults) { sResults.hidden = true; sResults.innerHTML = ''; }
      };
      sToggle.addEventListener('click', function () { setSearch(sBar.hidden); });
      var sClose = root.querySelector('#ihSearchClose');
      if (sClose) sClose.addEventListener('click', function () { setSearch(false); });
      if (sScrim) sScrim.addEventListener('click', function () { setSearch(false); });
      window.addEventListener('keydown', function (e) { if (e.key === 'Escape') setSearch(false); });
      /* close when clicking outside the bar (no scrim = no grey overlay) */
      document.addEventListener('click', function (e) {
        if (sBar.hidden) return;
        if (e.target.closest('#ihSearchBar') || e.target.closest('#ihSearchToggle')) return;
        setSearch(false);
      });

      /* predictive suggestions via Shopify search API */
      var sTimer = null;
      if (sInput && sResults) {
        sInput.addEventListener('input', function () {
          clearTimeout(sTimer);
          var q = sInput.value.trim();
          if (q.length < 2) { sResults.hidden = true; sResults.innerHTML = ''; return; }
          sTimer = setTimeout(function () {
            fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=4')
              .then(function (r) { return r.json(); })
              .then(function (d) {
                var hits = (d.resources && d.resources.results && d.resources.results.products) || [];
                if (!hits.length) { sResults.hidden = true; sResults.innerHTML = ''; return; }
                sResults.innerHTML = hits.map(function (p) {
                  var img = p.featured_image && p.featured_image.url ? '<img src="' + p.featured_image.url + '&width=120" alt="" loading="lazy">' : '';
                  return '<a class="sb-hit" href="' + p.url + '">' + img + '<div><b>' + p.title + '</b><span>' + (p.price ? '$' + p.price : '') + '</span></div></a>';
                }).join('');
                sResults.hidden = false;
              }).catch(function () {});
          }, 250);
        });
      }
    }

    /* mobile drawer */
    var drawer = root.querySelector('#drawer'), burger = root.querySelector('#burger');
    if (drawer && burger) {
      /* Sep 19 2026 (theme140): opening the drawer left focus on the burger, and
         Tab walked out behind the scrim. Focus now moves to Close on open, is
         held inside the panel, and returns to the burger on close. */
      var panel = drawer.querySelector('.drawer-panel'), isOpen = false;
      var closeBtn = root.querySelector('#drawerClose');
      var set = function (open) {
        if (open === isOpen) return;
        isOpen = open;
        drawer.classList.toggle('open', open);
        drawer.setAttribute('aria-hidden', String(!open));
        burger.setAttribute('aria-expanded', String(open));
        document.body.style.overflow = open ? 'hidden' : '';
        if (open) {
          if (closeBtn) setTimeout(function () { closeBtn.focus(); }, 60);
        } else if (drawer.contains(document.activeElement)) {
          burger.focus();
        }
      };
      burger.addEventListener('click', function () { set(true); });
      var close = closeBtn, scrim = root.querySelector('#drawerScrim');
      if (close) close.addEventListener('click', function () { set(false); });
      if (scrim) scrim.addEventListener('click', function () { set(false); });
      window.addEventListener('keydown', function (e) {
        if (!isOpen) return;
        if (e.key === 'Escape') { set(false); return; }
        if (e.key !== 'Tab' || !panel) return;
        var f = Array.prototype.filter.call(
          panel.querySelectorAll('a[href], button, summary, [tabindex]:not([tabindex="-1"])'),
          function (el) { return el.offsetParent !== null; });
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      });
      drawer.querySelectorAll('a').forEach(function (a) { a.addEventListener('click', function () { set(false); }); });
    }
  }

  if (!window.__ihv3hInit) {
    window.__ihv3hInit = true;
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { init(document); });
    } else {
      init(document);
    }
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  }
})();
